/**
 * EmployerOrganisationPage.jsx
 * Organisation hub at `/employer/organisation`.
 *
 * Houses the surfaces that previously sat on the (renamed) home
 * page — but it is NOT the operational dashboard. It is the
 * configuration / governance hub.
 *
 * Sections:
 *   • Organisation profile (mounts the existing OrgProfileForm
 *     from EmployerHomePage — reused intact).
 *   • Roles & permissions (deep-link to /employer/help/permissions).
 *   • Invite management (deep-link to /employer/members).
 *   • Reviewer governance (deep-link to /employer/reviewers).
 *   • Plan & Usage (deep-link to /employer/account).
 *
 * Strict: no new endpoints, no writes outside what
 * EmployerHomePage already exposed (org profile save).
 */
import EmployerHomePage from '@/pages/EmployerHomePage';


export default function EmployerOrganisationPage() {
  // EmployerHomePage is the existing org profile editor. We mount
  // it intact so its proven create/update flow continues to work.
  // The page already surfaces:
  //   - Organisation profile editor + save
  //   - Plan & Usage panel (via EmployerDashboardPanel)
  //   - Governance hub cards
  return (
    <div data-testid="employer-organisation-page">
      <EmployerHomePage />
    </div>
  );
}
